import { render, staticRenderFns } from "./AutoHedgeView.vue?vue&type=template&id=78a8d768&scoped=true"
import script from "./AutoHedgeView.vue?vue&type=script&lang=js"
export * from "./AutoHedgeView.vue?vue&type=script&lang=js"
import style0 from "./AutoHedgeView.vue?vue&type=style&index=0&id=78a8d768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a8d768",
  null
  
)

export default component.exports